import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=60d1d6b9"
import script from "./FlagIcon.vue?vue&type=script&lang=ts"
export * from "./FlagIcon.vue?vue&type=script&lang=ts"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=60d1d6b9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports